var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoucherNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 98,
    viewBox: "0 0 102 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 47,
    r: 47,
    fill: "#FBE1E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 51,
    r: 45.5,
    stroke: "#1C1C1C",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1911_13739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.667 41.6663V39.333M38.667 52.1663V49.833M38.667 62.6663V60.333M35.867 69.6663H60.1337C64.054 69.6663 66.0142 69.6663 67.5116 68.9034C68.8287 68.2323 69.8996 67.1614 70.5707 65.8443C71.3337 64.3469 71.3337 62.3867 71.3337 58.4663V43.533C71.3337 39.6126 71.3337 37.6525 70.5707 36.1551C69.8996 34.8379 68.8287 33.7671 67.5116 33.096C66.0142 32.333 64.054 32.333 60.1337 32.333H35.867C31.9466 32.333 29.9864 32.333 28.4891 33.096C27.1719 33.7671 26.1011 34.8379 25.4299 36.1551C24.667 37.6525 24.667 39.6126 24.667 43.533V58.4663C24.667 62.3867 24.667 64.3469 25.4299 65.8443C26.1011 67.1614 27.1719 68.2323 28.4891 68.9034C29.9864 69.6663 31.9466 69.6663 35.867 69.6663Z",
    stroke: "#101828",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1911_13739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(22.5 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherNotFound);
export default __webpack_public_path__ + "static/media/voucher-not-found.089769bdf408dea1ec9bcadf438246f1.svg";
export { ForwardRef as ReactComponent };